import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { jwtInterceptor } from './app/interceptors/jwt.interceptor';
import { problemDetailInterceptor } from './app/interceptors/problem-detail.interceptor';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID } from '@angular/core';
import { MAT_SORT_DEFAULT_OPTIONS } from '@angular/material/sort';
import 'dayjs/locale/nl';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { Http504Interceptor } from './app/interceptors/http504.interceptor';

// Configure dayjs
dayjs.locale('nl');
dayjs.extend(customParseFormat);

registerLocaleData(localeNl);

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    // problemDetailInterceptor is listed last so the DI-registered
    // Http504Interceptor still sees a raw HttpErrorResponse on the way out.
    provideHttpClient(withInterceptors([jwtInterceptor, problemDetailInterceptor]), withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    {
      provide: MAT_SORT_DEFAULT_OPTIONS,
      useValue: {
        disableClear: true
      }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http504Interceptor,
      multi: true
    }
  ]
}).catch(err => console.error(err));
